<template>
  <div>
    <common-hero :title="topTitle" :subTitle="topSubtitle" />
    <!--    contact-area-start-->
    <div class="contact-area" style="background-image: url(assets/img/contact.png)" v-if="showForm">
      <div class="container">
        <div class="row" v-if="title">
          <div class="col-lg-12">
            <div class="section-title">
              <h3 v-html="title"></h3>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="contact-form">
              <form @submit.prevent="startSubmit">
                <div class="single-contact">
                  <label for="#">Name*</label>
                  <input type="text" placeholder="Your first and last name" v-model="name" name="name" />
                  <div class="error">{{ validation.firstError('name') }}</div>
                </div>
                <div class="single-contact">
                  <label for="#">Email*</label>
                  <input type="email" placeholder="Example@email.com" v-model="email" name="email" />
                  <div class="error">{{ validation.firstError('email') }}</div>
                </div>
                <div class="single-contact">
                  <label for="#">Position*</label>
                  <input type="text" placeholder="Your position in your company or institution" v-model="position"
                    name="position" />
                  <div class="error">{{ validation.firstError('position') }}</div>
                </div>
                <!-- Special case Susbscribe for digital leaders -->
                <div v-if="type == 'subscribeDL' || type == 'bookDL'">
                  <b-form-group label="Occupation*" v-slot="{ ariaDescribedby }">
                    <b-form-radio-group id="job" :options="optionsJob" v-model="job" :aria-describedby="ariaDescribedby"
                      name="job"></b-form-radio-group>
                  </b-form-group>
                  <div v-if="type == 'subscribeDL'">
                    <div class="single-contact">
                      <label for="#">Company</label>
                      <input type="text" placeholder="your company" v-model="name" name="company" />
                    </div>
                    <div class="single-contact">
                      <label for="#" class="pb-2">Country</label>
                      <country-select v-model="country" :country="country" topCountry="US" autocomplete
                        placeholder="your country" className="country-select" />
                    </div>
                    <b-form-group label="Would you like to get notified?" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group id="yesno" :options="['yes', 'no']" :aria-describedby="ariaDescribedby"
                        name="notified"></b-form-radio-group>
                    </b-form-group>
                  </div>
                </div>
                <!-- end special case subscribeDL -->
                <!-- start special case bookDL -->
                <div v-if="type == 'bookDL' && job != 'Others' && job != ''" class="text-center">
                  <div class="gures-btn page-btn pt-3 text-center">
                    <a href="https://appoint.ly/s/emerging-group/30min" class="theme-btn">Schedule your meeting</a>
                  </div>
                </div>
                <div v-if="type == 'bookDL' && job == 'Others'">
                  Enter the reason for your Meeting inquiry:
                </div>
                <!-- end special case bookDL -->

                <div v-if="type == 'contact' || (type == 'bookDL' && job == 'Others')">
                  <div class="single-contact">
                    <label for="#">Subject</label>
                    <input type="text" placeholder="Subject of the message…" v-model="subject" name="subject" />
                    <input type="hidden" :name="hiddenName" :value="hiddenValue" />
                  </div>
                  <div class="single-contact">
                    <label for="#">Message*</label>
                    <textarea v-model="comment" id="comment" cols="30" rows="10" placeholder="Your message…"
                      name="comment"></textarea>
                    <div class="error">{{ validation.firstError('comment') }}</div>
                  </div>
                </div>
                <div class="single-contact-btn" v-if="showSubmit">
                  <button type="submit">Send</button>
                </div>
                <div class="single-contact-btn" v-else>
                  Submitting...
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contact-area" style="" v-else>
      <slot> </slot>
    </div>
    <!--    contact-area-end-->
  </div>
</template>

<script>
import CommonHero from '@/components/CommonHero';
import SimpleVueValidator from 'simple-vue-validator';
const Validator = SimpleVueValidator.Validator;
import { handleSubmit } from '@/api/forms';
export default {
  components: {
    CommonHero
  },
  props: {
    title: {
      type: String
    },
    subTitle: {
      type: String
    },
    hiddenName: {
      type: String,
      default: 'origin'
    },
    hiddenValue: {
      type: String,
      default: 'from Contact'
    },
    type: {
      type: String
    },
    topSubtitle: {
      type: String,
      default: ''
    },
    topTitle: {
      type: String,
      default: 'Contact'
    }
  },
  mixins: [SimpleVueValidator.mixin],
  validators: {
    email: function (value) {
      return Validator.value(value)
        .required()
        .email();
    },
    name: function (value) {
      return Validator.value(value)
        .required();
    },
    position: function (value) {
      return Validator.value(value)
        .required();
    }
    // comment: function(value) {
    //   return Validator.value(value).required();
    // }
  },
  data() {
    return {
      showMeeting: false,
      name: '',
      email: '',
      position: '',
      job: '',
      subject: '',
      comment: '',
      notified: '',
      action: 'https://submit-form.com/VGXXSUcR',
      showForm: true,
      showSubmit: true,
      optionsJob: [
        { text: 'Academic', value: 'Academic' },
        { text: 'Media', value: 'Media' },
        { text: 'Corporate', value: 'Corporate' },
        { text: 'Others', value: 'Others' }
      ],
      country: '',
      region: ''
    };
  },
  methods: {
    startSubmit() {
      let self = this;
      console.log('HERER');
      this.$validate().then(function (success) {
        console.log('SUCESSS', success);
        if (success) {
          self.showSubmit = false;
          handleSubmit(self.action, {
            name: self.name,
            email: self.email,
            position: self.position,
            subject: self.subject,
            comment: self.comment,
            job: self.job,
            country: self.country,
            company: self.company,
            notified: self.notified,
            type: self.type
          })
            .then(res => {
              self.showForm = false;
            })
            .catch(e => {
              console.log('Error', e);
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.error {
  color: red;
}

.country-select {
  width: 100%;
  padding-left: 20px;
  height: 48px;
  border: 1px solid #eeeff1;
  background: transparent;
  color: #142541;
}

.single-contact legend {
  font-size: 12px;
  color: #142541;
  display: block;
  margin: 0;
  line-height: 18px;
  margin-bottom: 4px;
  font-weight: 600;
  opacity: 0.4;
}
</style>
